module.exports = __webpack_public_path__ + "img/18.ba2b7cad.jpg";